// HARUS import pertama: membuang token link masuk dari URL sebelum router & GA4 membacanya.
import "./utils/tokenMasuk";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import SplashScreen from "./components/SplashScreen.vue";
import { alamatHalaman } from "./utils/analytics";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "./assets/css/main.css";

import store from "./store/index";
import "./registerServiceWorker";
import "pinch-zoom-element";

// =======================
// Google Analytics (GA4)
// =======================
const GA_ID = process.env.VUE_APP_GA_ID;

if (GA_ID) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  // page_view dikirim router.afterEach (catatHalaman di utils/analytics.js) dengan alamat yang
  // disamarkan, jadi config tidak boleh mengirim page_view sendiri dari URL asli. Alamat awal
  // disamarkan juga untuk event yang terkirim sebelum router selesai.
  const awal = router.resolve(window.location.pathname + window.location.search + window.location.hash);

  // Perujuk juga bisa halaman aplikasi ini sendiri — interceptor memuat ulang penuh ke /login
  // dari halaman mana pun saat sesi habis, termasuk riwayat luka — jadi ikut disamarkan.
  let perujuk = document.referrer;
  if (perujuk.startsWith(window.location.origin + "/")) {
    const asal = new URL(perujuk);
    perujuk = asal.origin + alamatHalaman(router.resolve(asal.pathname + asal.search + asal.hash));
  }

  window.gtag("js", new Date());
  window.gtag("set", { page_location: window.location.origin + alamatHalaman(awal), page_referrer: perujuk });
  window.gtag("config", GA_ID, {
    debug_mode: process.env.NODE_ENV !== "production",
    send_page_view: false,
  });

  // Pulihkan user_id (pseudonim) kalau user sudah login di sesi sebelumnya,
  // supaya DAU/MAU tetap akurat lintas reload/kunjungan.
  const storedUser = localStorage.getItem("memberId");
  if (storedUser) {
    window.gtag("config", GA_ID, { user_id: storedUser, send_page_view: false });
  }
}

// =======================
// Create App
// =======================
const app = createApp(App);

app.component("SplashScreen", SplashScreen);
app.use(store);
app.use(router);

app.mount("#app");
